module.exports = __webpack_public_path__ + "img/cgceo.5682ef63.png";